import React from "react";
import "./About-industrial.css";
import { motion } from "framer-motion";
import isoLogo from "../../assets/iso-white.png"; 
import qualityIcon from "../../assets/One-Stop-Solutions.svg";
import innovationIcon from "../../assets/Global-Local.svg";
import partnershipIcon from "../../assets/Relationships-First.svg";
import reliabilityIcon from "../../assets/Our-Values.svg";

const AboutUsSection = () => {
  const isMobile = window.innerWidth <= 768; // check screen size

  return (
    <section className="aboutus-section">
      <div className="aboutus-wrapper">
        <div className="aboutus-left-colur"></div>
        <div className="aboutus-container">
          
          {/* LEFT SIDE */}
          <motion.div
            className="aboutus-left"
            initial={isMobile ? false : { opacity: 0, y: -80 }}
            whileInView={isMobile ? {} : { opacity: 1, y: 0 }}
            transition={isMobile ? {} : { duration: 0.8, ease: "easeOut" }}
            viewport={isMobile ? {} : { once: false, amount: 0.3 }}
          >
            {/* ISO logo positioned in top-right */}
            <div className="aboutus-iso-left">
              <img src={isoLogo} alt="ISO Certification" />
            </div>

            <h4 className="aboutus-subtitle">About Us – Sreenathji Enterprises</h4>
            <h2 className="aboutus-title">
              <span>A Legacy of Trust Since 1982</span>
            </h2>
            <p className="aboutus-founders">
              Sreenathji Enterprises (SE) was established in 1982 with a humble vision — to
serve the industrial sector with quality products and reliable service. Over the
decades, what began as a modest venture has grown into one of the leading
distribution houses in Karnataka and Hosur region, trusted by industries across
the country.
            </p>
            <p className="aboutus-desc">
             Over the years, we’ve built strong associations as authorized distributors for toptier multinational companies in Specialty chemicals, Abrasives, Wood
coatings, Corrosion resistant paints, Basic chemicals and
Cutting tools. Our strong partnerships and dedication allow us to deliver premium
solutions that meet the evolving demands of our customers. In addition, Sreenathji
Enterprises is also an importer of high-grade metals like Nickel, Zinc, Tin and
Copper from across the globe.
            </p>
            <p className="aboutus-desc">
             Sreenathji Enterprises is supported by a passionate, skilled team that shares a
common commitment — to excellence, integrity, and trusted distribution. Our team
brings decades of insight, customer-first service, and a deep understanding of
industry needs to every interaction.
            </p>
            <p className="aboutus-desc">
              At SE, we are not just suppliers; we are partners in progress. Our mission is to not
only to meet the current needs of the industry but also to introduce new
technologies and avenues in the form of products that shape the future as we
believe the best is yet to come.
            </p>
          </motion.div>

          {/* RIGHT SIDE */}
          <motion.div
  className="aboutus-right"
  initial={isMobile ? false : { opacity: 0, y: 80 }}
  whileInView={isMobile ? {} : { opacity: 1, y: 0 }}
  transition={isMobile ? {} : { duration: 0.8, ease: "easeOut", delay: 0.2 }}
  viewport={isMobile ? {} : { once: false, amount: 0.3 }}
>
<div className="aboutus-right-attractive">
  <div className="feature">
    <div className="feature-icon">
      <img src={qualityIcon} alt="One-Stop Solutions" />
    </div>
    <div className="feature-content">
      <h3>One-Stop Solutions</h3>
      <p>We offer complete industrial solutions from one place, ensuring seamless integration for all your industrial needs.</p>
    </div>
  </div>

  <div className="feature">
    <div className="feature-icon">
      <img src={innovationIcon} alt="Global & Local" />
    </div>
    <div className="feature-content">
      <h3>Global & Local</h3>
      <p>We distribute global brands with local know-how, combining international standards with regional expertise.</p>
    </div>
  </div>

  <div className="feature">
    <div className="feature-icon">
      <img src={partnershipIcon} alt="Relationships First" />
    </div>
    <div className="feature-content">
      <h3>Relationships First</h3>
      <p>We focus on long-term relationships, not just one-time sales, prioritizing trust, collaboration, and mutual growth.</p>
    </div>
  </div>

  <div className="feature">
    <div className="feature-icon">
      <img src={reliabilityIcon} alt="Our Values" />
    </div>
    <div className="feature-content">
      <h3>Our Values</h3>
      <p>We are committed to quality, integrity, and trust, and every project we deliver reflects our dedication to excellence.</p>
    </div>
  </div>

  {/* Floating shapes for visual effect */}
  <span className="shape circle"></span>
  <span className="shape square"></span>
  <span className="shape triangle"></span>
</div>

</motion.div>
        </div>
      </div>
    </section>
  );
};

export default AboutUsSection;
